export default {
  headline: "Unfallmeldung",
  reporter: "Unfallmelder",
  reg_nr: "Reg.-Nr.",
  date: "Datum",
  time: "Uhrzeit",
  line: "Linie",
  from_stop: "Fahrt von Haltestelle",
  to_stop: "Nach Haltestelle",
  driver: "Fahrer*",
  driver_invalid: "Bitte geben sie einen Unfallfahrer an",
  accident_vehicle: "Unfallfahrzeug*",
  accident_vehicle_invalid: "Bitte geben Sie ein Unfallfahrzeug an",
  accident_site: {
    headline: "Unfallort (genau)",
    location: "Unfallort*",
    location_invalid: "Bitte geben Sie einen Unfallort an",
    street_number: "Straße / Hnr.",
    side_street: "Nebenstraße",
  },
  road_condition: "Fahrbahnzustand*",
  road_condition_invalid: "Bitte geben sie einen Fahrbahnzustand an",
  weather: "Witterung*",
  weather_invalid: "Bitte geben Sie eine Witterung an",
  pictures: "Bilder",
  files_upload_placeholder: "Bilder hochladen",
  involved_vehicles: "Andere am Unfall beteiligte Fahrzeuge",
  other_involved: "Andere am Unfall beteiligte Verkehrsteilnehmer",
  accident_involved: {
    headline: "Involvierte Personen",
    domicile: "Wohnort",
    location: "Ortsteil / Straße / Nr.",
    plate: "Kennzeichen",
    brand: "Fabrikat",
    insurance_name: "Name der Versicherung",
    insurance_number: "Vers. Schein-Nr.",
  },
  damage: {
    headline: "Angaben zum Unfallschaden",
    damage_statement: "Schadensangabe*",
    damage_statement_invalid: "Bitte geben sie eine Schadensangabe an",
    third_party_damage: "Fremdschaden",
    old_damage: "Altschaden",
    own_damage: "Eigener Schaden"
  },
  more_informations: {
    headline: "weitere Angaben",
    bus_type: "Bustyp?",
    advertisement_damaged: "Reklame beschädigt?",
    foreman_present: "War der Betriebsmeister am Unfallort?",
    police_record: "Hat die Polizei den Unfall aufgenommen?",
    acknowledgment_of_guilt: {
      label: "Schuldanerkenntnis",
      no_one: "Keiner",
      the_other: "der Andere",
      self: "selbst"
    },
    acknowledgment_of_guilt_no: "Schriftl. Schuldanerkenntnis",
    file_number: "Aktenzeichen",
    cause_of_accident: "Unfallursache",
    the_accident: "Unfallhergang*",
    the_accident_invalid: "Bitte beschreiben Sie den Unfallhergang"
  },
  warnings: {
    headline: "Angaben zu Verwarnungen",
    cautioned: {
      label: "Verwarnter",
      no_one: "Keiner",
      the_other: "der Andere",
      self: "selbst"
    },
    police: "Polizeiliche Verwarnung",
    oral: "Mündliche Verwarnung",
    chargeable: "Gebührenpflichtige Verwarnung"
  },
  drawing: {
    headline: "Unfallskizze",
    no_drawing: "Keine Unfallskizze hinterlegt",
    create_drawing: "Unfallskizze anlegen",
    change_drawing: "Unfallskizze ändern"
  },
  signature: {
    reporter: "Unterschrift Unfallmelder*",
    reporter_invalid: "Die Unterschrift des Unfallmelders fehlt",
    foreman: "Unterschrift FM/TL*",
    foreman_invalid: "Die Unterschrift des Betriebsleiters fehlt",
  },
  report_damage: "Schaden melden"
}
